<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="900">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-FACILITY' : 'EDIT-FACILITY') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm">
        <kendo-tabstrip #tabstrip>
            <kendo-tabstrip-tab title="{{ 'FACILITY' | translate }}" [selected]="true">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <div class="row">
                            <div class="col">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'NAME' | translate}} *
                                    </span>
                                    <input id="name" kendoTextBox formControlName="name" maxlength="255" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="name.invalid && name.touched">
                                        {{'REQUIRED-NAME' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'DESCRIPTION' | translate}}
                                    </span>
                                </label>
                                <textarea id="description" kendoTextArea rows="4" formControlName="description"
                                    class="w-100" maxlength="4000">
                                    </textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'FACILITY-NPI' | translate}}
                                    </span>
                                    <input id="npi" kendoTextBox formControlName="npi" maxlength="50" />
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'ADDRESS' | translate }}">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <div class="row">
                            <div class="col-8">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'STREET' | translate}}
                                    </span>
                                    <input id="streetLine" kendoTextBox formControlName="streetLine" class="w-100" /> <i
                                        *ngIf="addressAPIEnabled && streetLine.value"
                                        class="far fa-search-location pointer ml-3 fa-1_5x"
                                        style="color:#3e807c;position:absolute;top:43px;"
                                        title="{{'VALIDATE-ADDRESS-ICON' | translate}}" (click)="validateAddress()"></i>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ADDRESS-LINE-2' | translate}}
                                    </span>
                                    <input id="streetLineAdditional" kendoTextBox formControlName="streetLineAdditional"
                                        class="w-100" />
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'CITY' | translate}}
                                    </span>
                                    <input id="city" kendoTextBox formControlName="city" class="w-100" />
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'COUNTY' | translate}}
                                    </span>
                                    <input id="county" kendoTextBox formControlName="county" class="w-100"
                                        maxlength="150" />
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'STATE' | translate}}
                                    </span>
                                    <kendo-combobox id="state" class="w-100" formControlName="state" [data]="states"
                                        [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="false">
                                    </kendo-combobox>
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'POSTAL-CODE' | translate}}
                                    </span>
                                    <input id="postalCode" kendoTextBox formControlName="postalCode" class="w-100" />
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'COUNTRY' | translate}}
                                    </span>
                                    <kendo-combobox id="country" class="w-100" formControlName="country"
                                        [data]="countries" [textField]="'displayName'" [valueField]="'code'"
                                        [valuePrimitive]="false">
                                    </kendo-combobox>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'CONTACT' | translate }}">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <div class="row">
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-phone fa-fw"></i> {{'PHONE' | translate}}
                                    </span>
                                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="telephoneNumber"
                                        formControlName="telephoneNumber" class="w-100">
                                    </kendo-maskedtextbox>
                                </label>
                            </div>
                            <div class="col-3 pl-0">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">{{'PHONE-EXTENSION' | translate}}
                                    </span>
                                    <input id="telephoneNumberExtension" kendoTextBox
                                        formControlName="telephoneNumberExtension" class="w-100" maxlength="20" />
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-mobile-android-alt fa-fw"></i> {{'CELL-PHONE' | translate}}
                                    </span>
                                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="cellPhoneNumber"
                                        formControlName="cellPhoneNumber" class="w-100">
                                    </kendo-maskedtextbox>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-fax fa-fw"></i> {{'FAX' | translate}}
                                    </span>
                                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="faxNumber"
                                        formControlName="faxNumber" class="w-100">
                                    </kendo-maskedtextbox>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i (click)="openUrl()" [ngClass]="{'has-valid-url': isValidUrl()}"
                                            class="fas fa-link fa-fw"></i> {{'FACILITY-URL' | translate}}
                                    </span>
                                    <input id="url" kendoTextBox formControlName="url" maxlength="255" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="!isValidUrl() && url.hasError('pattern') && url.touched">
                                        {{'INVALID-WWW' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
        <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
    </form>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty || saving"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<app-address-validator #addressValidator (changeAddress)="changeAddress($event)" (save)="saveFacility()"
    (cancelling)="saving = false;">
</app-address-validator>